import { Link, Typography } from "@mui/material";

export const MarketingOptInLabel = () => (
  <Typography variant={"body2"} color={"text.secondary"}>
    By submitting this form, you agree to receive marketing emails from Cascade
    Energy. You can unsubscribe at any time. See our{" "}
    <Link href={"https://cascadeenergy.com/privacy-policy"} target="_blank">
      Privacy Policy
    </Link>{" "}
    for more information on how we use your data.
  </Typography>
);
